module.exports = __webpack_public_path__ + "static/nas.e425f4e7.png";